import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../src/environments/environment';

type Pixel = ((...args: unknown[]) => void) & {q?: unknown[][]; l?: number};
type PixelWindow = Window & {bp?: Pixel; barion_pixel_id?: string};

@Injectable({providedIn: 'root'})
export class PlatformPixelService {
  private http = inject(HttpClient);
  private document = inject(DOCUMENT);
  private started = false;
  init(): void {
    if (this.started) return;
    this.started = true;
    this.http.get<{data: {barionPixelId: string | null}}>(`${environment.apiUrl}/platform/payment-config`).subscribe({
      next: ({data}) => this.install(data.barionPixelId),
      error: () => { this.started = false; },
    });
  }
  private install(id: string | null): void {
    const win = this.document.defaultView as PixelWindow | null;
    if (!win || !id || !/^BP-[a-zA-Z0-9]{10}-[0-9]{2}$/.test(id)) return;
    if (this.document.getElementById('platform-barion-pixel')) return;
    const queue: Pixel = (...args: unknown[]) => { (queue.q ??= []).push(args); };
    queue.l = Date.now();
    win.bp ??= queue;
    win.barion_pixel_id = id;
    const script = this.document.createElement('script');
    script.id = 'platform-barion-pixel';
    script.async = true;
    script.src = 'https://pixel.barion.com/bp.js';
    this.document.head.prepend(script);
    win.bp('init', 'addBarionPixelId', id);
  }
}
